import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import Headroom from 'react-headroom'
import { getNav } from './component-helpers/getnav'
import navStyles from '../../styles/nav.less'
import { setRichieParam, getParameterByName } from './component-helpers/utilfunctions'

const checkApp = () =>{
  if (typeof window !== "undefined"){
    let param = getParameterByName("fromRichie")
    if (param){
      return true
    } else {
      return false
    }
  } else {
    // If window is undefined, return empty
    return []
  }
}
const NavTop = ({ meta, url_add = '' }) => {
  let [showSubnav, setShowSubnav] = useState(false)

  // Override these with link objects (example below) if you want to customize
  let coronavirusUrl = meta.coronavirusUrl ? meta.coronavirusUrl : ''
  let navLink = {
    text: 'CORONAVIRUS',
    url: coronavirusUrl,
    target: "_blank"
  }
  let sectionArray = null

  // Enable the social popup
  let handleNavClick = (e) => {
    // Handle facebook
    let el = e.target.closest('#topper-nav-facebook-icon')
    if (el && e.currentTarget.contains(el)) {
      const link = el.getAttribute('href')
      e.preventDefault()
      window.open(link, 'facebook-share-dialog', 'width=626,height=436')
    }
    // Handle subnav
    // el = e.target.closest("#nav-title");
    // if (el && e.currentTarget.contains(el)) {
    //   e.preventDefault()
    //   setShowSubnav(!showSubnav)
    // }
    // Handle closing subnav
    el = e.target.closest('#subnav')
    if (el && e.currentTarget.contains(el)) {
      setShowSubnav(false)
    }
  }

  //If this is CT, we need to reset state
  let startingHTML = ''
  if (meta.PROJECT.MARKET_KEY !== 'CT') {
    startingHTML = getNav(meta, url_add, null, navLink, sectionArray, checkApp())
  }
  let [navHTML, setNavHTML] = useState(startingHTML)
  let [app, setApp] = useState(false)
  // Setting nav now so that other CT markets can generate
  useEffect(() => {
    setApp(checkApp())
    let navLinkarr = setRichieParam([navLink])
    setNavHTML(getNav(meta, url_add, null, navLinkarr[0], sectionArray, checkApp()))
  }, [])

  return (
    <Headroom
      style={{
        zIndex: '2147483647',
      }}
    >
      {!app && <div
        className={showSubnav ? 'show-subnav' : ''}
        onClick={(e) => {
          handleNavClick(e)
        }}
        /* 
        getNav params:
          1. meta 
          2. url_add 
          3. force color ("white", "black" or null)
          4. navlink object {
              text,
              url,
              target
            }
          5. array of link objects for subnav 
        */
        dangerouslySetInnerHTML={{ __html: navHTML }}
      />}
    </Headroom>
  )
}

NavTop.propTypes = {
  meta: PropTypes.object.isRequired,
  url_add: PropTypes.string,
}

export default NavTop
